"use client";
import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Content,
  Header,
  Loader,
  SelectPicker,
} from "rsuite";
import { Form, Field, FormSpy } from "react-final-form";
import { MediaServices } from "../../../core/services/MediaServices";
import "./Media.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useTranslation } from "react-i18next";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { MediaFields } from "./MediaDataTypes";
import {
  messageTypeArr,
  songTypeObjArr,
} from "../../../core/config/AppConstants";
import { ContentRoutes } from "../../../navigation/NavConstant";
import { isNotNull } from "../../../utils/helpers";
import MediaFileUpload from "../../components/Elements/MediaFileUpload";
import ImageUpload from "../../components/Elements/ImageUpload";
function Media() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loader, setLoading] = useState(false);
  const [mediaFetched, setMediaFetched] = useState(false);

  const params: any = useParams();
  const [mediaImageFile, setMediaImageFile] = useState<any>();
  const [mediaImage, setMediaImage] = useState("");
  const [mediaPlayUrl, setMediaPlayUrl] = useState<string>();
  const [mediaFile, setMediaFile] = useState<any>(null);

  const [mediaData, setMediaData] = useState<MediaFields>({});

  const [errorMessage, setErrorMessage] = useState("");
  let [decryptedParams] = useDecryptedParams(params);

  const ecryptedMediaId = encryptUrl(`${decryptedParams.id}`);

  const [formData, setFormData] = useState<any>({
    name: "",
    file_name: null,
    media_image: null,
    singer1_name: "",
    song_type: "",
    media_type: "audio",
    album_name: "",
    status: 1,
  });

  async function init() {
    try {
      if (decryptedParams.id) {
        setMediaFetched(false);
        setLoading(true);
        const response: any = await MediaServices.viewMedia(
          +decryptedParams.id,
        );
        const mdData: any = response?.data?.data;
        const keyMapper: any = { name: "title" };
        setMediaData(mdData);
        let obj = { ...formData };
        //review comment: response?.data?.data? should be in a single variable and then used further upon;
        if (mdData?.media_image_url) {
          setMediaImage(mdData?.media_image_url);
        }
        if (mdData?.media_file_url) {
          setMediaPlayUrl(mdData?.media_file_url);
        }
        let keyMapperIndex = Object.keys(keyMapper);
        Object.keys(obj).map((formKey) => {
          if (keyMapperIndex.includes(formKey)) {
            obj[formKey] = mdData[keyMapper[formKey]];
          } else {
            obj[formKey] = mdData[formKey];
          }
        });
        setFormData({ ...obj });

        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setMediaFetched(true); // Mark component as ready to render
    }
  }

  useEffect(() => {
    init();
  }, [decryptedParams.id]);

  useEffect(() => {}, []);

  async function saveSong(form: any, songId?: any) {
    try {
      setLoading(true);
      let response: any;
      if (songId) {
        response = await MediaServices.updateMedia(+songId, form);
      } else {
        response = await MediaServices.createMedia(form);
      }
      setMediaData(response?.data?.data);
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
      navigate(ContentRoutes.MEDIAS);
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setErrorMessage(error?.message);
    }
  }

  const onSubmit = (val: any) => {
    const form = new FormData();
    const fileFieldNames = [
      "file_name",
      "media_image",
      "song_file",
      "image",
      "_song_file",
      "_image",
    ];
    for (var key in val) {
      if (isNotNull(val[key]) && !fileFieldNames.includes(key))
        form.append(key, val[key]);
    }
    if (mediaImageFile instanceof File && mediaImageFile.size > 0) {
      form.append("media_image", mediaImageFile, mediaImageFile.name);
    }

    if (mediaFile instanceof File && mediaFile.size > 0) {
      form.append("file_name", mediaFile, mediaFile.name);
    }

    form.delete("song_file");
    form.delete("image");

    if (decryptedParams.id) {
      saveSong(form, decryptedParams.id);
    } else {
      saveSong(form);
    }
  };

  const handleFormValuesChange = (values: any) => {
    setTimeout(() => {
      setFormData(values);
    }, 0);
  };

  return (
    <div className="song">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Container className="container">
        <Header className="header">
          <h4 className="mb-3">
            {decryptedParams.id ? t("UPDATE") : t("CREATE")} {t("MEDIA")}
          </h4>
        </Header>
        <Content className="content song-create-wrap">
          <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
              const errors: any = {};
              if (!values.name) {
                errors.name = t("REQUIRED", {
                  field:
                    t("MEDIA").toLowerCase() + " " + t("NAME").toLowerCase(),
                });
              }
              if (!(mediaFile instanceof File) && !decryptedParams.id) {
                errors.song_file = t("REQUIRED_SELECT", {
                  field:
                    t("MEDIA").toLowerCase() + " " + t("FILE").toLowerCase(),
                });
              }
              if (!values.song_type) {
                errors.song_type = t("REQUIRED_SELECT", {
                  field:
                    t("MEDIA").toLowerCase() + " " + t("TYPE").toLowerCase(),
                });
              }
              if (!values.singer1_name) {
                errors.singer1_name = t("REQUIRED", {
                  field:
                    t("MEDIA").toLowerCase() +
                    " " +
                    t("SINGER1").toLowerCase() +
                    " " +
                    t("NAME").toLowerCase(),
                });
              }
              return errors;
            }}
            initialValues={{ ...formData }}
            render={({ handleSubmit, form, errors, submitFailed }) => (
              <form onSubmit={handleSubmit}>
                {mediaFetched && (
                  <MediaFileUpload
                    name="_song_file"
                    mediaFile={mediaFile}
                    setMediaFile={setMediaFile}
                    mediaUrl={mediaPlayUrl}
                    maxUploadSize={10}
                    errorMessage={submitFailed ? errors?.song_file : ""}
                  />
                )}

                {mediaFetched && (
                  <ImageUpload
                    name="_image"
                    entityImage={mediaImage}
                    setEntityImageFile={(v: File) => {
                      if (v && v.size) {
                        setMediaImageFile(v);
                        setMediaImage(URL.createObjectURL(v));
                      } else {
                        setMediaImageFile(null);
                        setMediaImage(null);
                      }
                    }}
                  />
                )}
                <div className="form-part">
                  <div className="flex-container">
                    <Field name="name">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("MEDIA")} {t("TITLE")}*
                          </label>
                          <input {...input} type="text" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="song_type">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("MEDIA")} {t("TYPE")}*
                          </label>
                          <SelectPicker
                            data={songTypeObjArr?.length ? songTypeObjArr : []}
                            valueKey="value"
                            labelKey="label"
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("song_type", e);
                            }}
                            onClean={(event: any) => {
                              form.change("song_type", "");
                            }}
                            name="song_type"
                            placeholder={t("MEDIA") + " " + t("TYPE")}
                            value={input.value}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>

                  <div className="flex-container">
                    <Field name="album_name">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("ALBUM")} / {t("MOVIE")}
                          </label>
                          <input {...input} type="text" autoComplete="off" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="singer1_name">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("SINGER")} {t("NAME")}*
                          </label>
                          <input {...input} type="text" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                </div>
                <div className="create-action d-flex flex-end">
                  <Link to={ContentRoutes.MEDIAS}>
                    <Button appearance="primary" color="blue" type="button">
                      {t("BACK")} {t("TO").toLocaleLowerCase()}{" "}
                      {t("LIST").toLocaleLowerCase()}
                    </Button>
                  </Link>
                  <Button appearance="primary" color="green" type="submit">
                    {decryptedParams.id ? t("UPDATE") : t("CREATE")}
                  </Button>
                  <Button
                    appearance="default"
                    type="reset"
                    onClick={() => {
                      // review comment: move to new function
                      form.reset();
                      setMediaImageFile("");
                      setMediaImage("");
                      setMediaPlayUrl("");
                      setMediaFile("");
                    }}
                  >
                    {t("RESET")}
                  </Button>
                </div>
                <FormSpy
                  subscription={{ values: true }}
                  onChange={({ values }) => handleFormValuesChange(values)}
                />
              </form>
            )}
          />
        </Content>
      </Container>
    </div>
  );
}

export default Media;
